import React from 'react';

interface Notice {
  id: number;
  date: string;
  title: string;
  url?: string;
  endDatetime?: string; // ISO 8601形式 例: '2026-01-31T23:59:59'
}

const notices: Notice[] = [
  {
    id: 1,
    date: '2026-07-31',
    title: '「精子ドナー募集掲示板」開設から1ヶ月のデータを公開しました！本当にドナーの応募は来るの？詳しくは公式noteをご覧ください。',
    url: 'https://note.com/tonbebe/n/nf7afdf199816',
    endDatetime: '2026-08-15T23:59:59',
  },
];

const Notices = () => {
  const now = new Date();
  const activeNotices = notices.filter((notice) => {
    if (!notice.endDatetime) return true;
    return new Date(notice.endDatetime) > now;
  });

  if (activeNotices.length === 0) {
    return null;
  }

  return (
    <section className="notices">
      <div className="inner">
        <h2>お知らせ</h2>
        <ul>
          { activeNotices.map((notice) => (
            <li key={ notice.id }>
              <time dateTime={ notice.date }>{ notice.date.replace(/-/g, '.') }</time>
              { notice.url ? (
                <a href={ notice.url } target="_blank" rel="noopener noreferrer">
                  { notice.title }
                </a>
              ) : (
                <span>{ notice.title }</span>
              ) }
            </li>
          )) }
        </ul>
      </div>
    </section>
  );
}

export default Notices;
